import {BaseModel} from "./base"
import {JsonProperty} from "../requests/jsonparser";

export class CategoryMedia {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'CategoryMedia' })
    MODELNAME: string;


    @JsonProperty({ type: 'string' })
    scope: string;

    @JsonProperty({ type: 'string' })
    image_url: string;

}



// WEBPACK FOOTER //
// ./src/api/src/models/category_media.ts